
















import { Component, Vue, Prop } from 'vue-property-decorator';

import CopyInput from '@/components/CopyInput/CopyInput.vue';

@Component({
  components: {
    CopyInput
  }
})
export default class ShareBanner extends Vue {
  @Prop({ required: true }) link!: string;

  showSuccess() {
    this.$notification('Link copied to your clipboard', 'success');
  }

  fallbackCopyTextToClipboard() {
    const textArea = document.createElement('textarea');
    textArea.value = this.link;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
    this.showSuccess();
  }

  copy() {
    const navigator: any = window.navigator;
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard();
      return;
    }
    navigator.clipboard
      .writeText(this.link)
      .then(this.showSuccess)
      .catch((err: any) => {
        console.error('Async: Could not copy text: ', err);
      });
  }
}
